import React from 'react'

import PropTypes from 'prop-types'
import { setPropTypes } from 'recompose'

const PureHtml = ({ html }) => <div id="message" dangerouslySetInnerHTML={{ __html: html }} />

const enhance = setPropTypes({
  html: PropTypes.string.isRequired
})

export default enhance(PureHtml)
